import React, { useState, useEffect, useMemo, useCallback } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import FormCustom from '../../Components/Form/FormCustom';
import Select from '../../Components/Form/Select';
import Button from 'react-bootstrap/esm/Button';
import Input from '../../Components/Form/Input';

const Commissions = ({ type }) => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState({
        customer: {},
        details: [],
        exchange: [],
        total_earnings: 0
    })
    const [periodSelected, setPeriodSelected] = useState({
        p_id_period: '',
        p_id_customers: ''
    })
    const [period, setPeriod] = useState([])
    const [reporte, setReport] = useState({})

    useEffect(() => {
        Controllers.period.get_period().then(res => {
            setPeriod(res.data)
        })
    }, [])

    const isAdmin = useCallback(() => type === 'admin', [type])

    const handleSubmit = () => {
        if (periodSelected.p_id_period === '') {
            Helpers.toast.construct({ response: 'warning', message: 'Seleccione un periodo', toast })
            return;
        }
        if (isAdmin() && periodSelected.p_id_customers === '') {
            Helpers.toast.construct({ response: 'warning', message: 'Ingrese el ID del cliente raíz', toast })
            return;
        }

        setIsProccesing(true)
        setReport({}) // Limpiar reporte anterior
        Controllers.red.get_my_commissions(periodSelected).then(res => {
            if (res.response !== 'success') {
                Helpers.toast.construct({ ...res, toast })
                return
            }
            setRows(res.data)
            setReport({
                excel: res.data.excel.file,
                filename: res.data.excel.filename,
            })
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                {
                    name: 'id_customers', text: 'ID', align: 'center', classBodyTr: r => {
                        return parseInt(r?.has_exchange) === 1 ? 'bg-info text-white' : ''
                    }
                },
                { name: 'full_name', text: 'Nombres', },
                { name: 'point_business_customers', text: 'Valor Negocio', align: 'center', },
                { name: 'nivel', text: 'Nivel', align: 'center', },
                { name: 'percentage_nivel', text: 'Porcentaje Nivel', align: 'center', render: r => r.percentage_nivel ? r.percentage_nivel + '%' : '' },
                { name: 'generation', text: 'Generación', align: 'center', },
                { name: 'percentage_generation', text: 'Porcentaje Generación', align: 'center', render: r => r.percentage_generation ? r.percentage_generation + '%' : '' },
                { name: 'subtotal_earnings', text: 'Ganancia', align: 'center', render: r => '$ ' + r.subtotal_earnings },
                { name: 'code_money', text: 'Moneda', align: 'center', },
            ],
        ]}
        rows={rows.details}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>{isAdmin() ? 'Detalle de Comisiones' : 'Comisiones'}</span>
            </Card.Header>
            <Card.Body>
                <FormCustom viewSubmit={false} onSubmit={handleSubmit}>
                    {isAdmin() && <Input
                        type="number"
                        text="Cliente"
                        placeholder="Cliente"
                        classNameParent="col-6 mb-2"
                        icon="far fa-user"
                        invalid="El campo es obligatorio."
                        onChange={e => setPeriodSelected({
                            ...periodSelected,
                            p_id_customers: e.currentTarget.value
                        })}
                        maxLength={30}
                        required
                    />}
                    <Select
                        text="Periódo"
                        classNameParent={'mb-2 ' + (isAdmin() ? 'col-6' : 'col-12')}
                        options={period.map(p => {
                            return {
                                label: p.name_period,
                                value: p.id_period
                            }
                        })}
                        onChange={e => setPeriodSelected({
                            ...periodSelected,
                            p_id_period: e.value
                        })}
                        append={[
                            <Button type="submit">
                                <i className="fa fa-search"></i>
                            </Button>
                        ]}
                    />
                </FormCustom>
                <div className="d-flex">
                    {reporte?.filename ? <div className='mt-2 mb-2 mr-2'>
                        <a href={reporte?.excel} download={reporte?.filename}>
                            <Button size="sm" variant="success">
                                <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                            </Button>
                        </a>
                    </div> : ''}
                </div>
                {dtRows}
            </Card.Body>
        </Card>
        {isProcessing ? '' : <>
            {rows.exchange.length > 0 ? <Card className="mt-4">
                <Card.Header>
                    <span>Detalle de Conversiones</span>
                </Card.Header>
                <Card.Body>
                    <div className="table-responsive">
                        <table className="table table-sm table-hover table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>ID Cliente</th>
                                    <th>Cliente</th>
                                    <th>Moneda</th>
                                    <th>Ganancia</th>
                                    <th>Conversión</th>
                                    <th>Ganancia Conversión</th>
                                </tr>
                            </thead>
                            <tbody>
                                {React.Children.toArray(rows.exchange.map(e => {
                                    return <tr>
                                        <td>{e.id_customers}</td>
                                        <td>{e.full_name}</td>
                                        <td align="center">{e.code_money}</td>
                                        <td align="center">{e.subtotal_earnings}</td>
                                        <td align="center">{e.value_exchange}</td>
                                        <td align="center">{e.subtotal_exchange}</td>
                                    </tr>
                                }))}
                            </tbody>
                        </table>
                    </div>
                </Card.Body>
            </Card> : ''}
            <div className="d-flex justify-content-center mt-4">
                <div className="alert alert-success text-center">
                    <h5>Total de Comisiones: <strong>{rows.customer.code_money} {rows.total_earnings}</strong></h5>
                    <small>Total de comisiones antes de impuesto.</small>
                </div>
            </div>
        </>}

    </>
}

Commissions.defaultProps = {
    type: 'dashboard'
}

export default Commissions
